// Contract EndDate edits use an inclusive UTC date and store next-day midnight.
// See clients/src/contract_edits/mod.rs, FieldIdentifier::EndDate.
export function energyDateCutoff(value: string): string | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
  const date = new Date(`${value}T00:00:00.000Z`);
  if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== value) return null;
  date.setUTCDate(date.getUTCDate() + 1);
  return date.getUTCFullYear() > 9999 ? null : date.toISOString();
}

export function currentLastEnergyDate(endTime?: string | null): string {
  if (!endTime) return "";
  const date = new Date(endTime);
  if (!Number.isFinite(date.getTime())) return "";
  date.setUTCDate(date.getUTCDate() - 1);
  return date.toISOString().slice(0, 10);
}

export function validateLastEnergyDate(value: string, beginTime?: string | null): true | string {
  const cutoff = energyDateCutoff(value);
  if (!cutoff) return "Enter a valid last energy date (YYYY-MM-DD).";
  if (beginTime && new Date(cutoff).getTime() <= new Date(beginTime).getTime()) {
    return "Last energy date must be on or after the contract begin date.";
  }
  return true;
}
